import { render, staticRenderFns } from "./ByAllauthorized.vue?vue&type=template&id=35b0a899"
import script from "./ByAllauthorized.vue?vue&type=script&lang=js"
export * from "./ByAllauthorized.vue?vue&type=script&lang=js"
import style0 from "./ByAllauthorized.vue?vue&type=style&index=0&id=35b0a899&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports